<template>
  <div class="label-group-preview">
    <el-table :data="tableData" border :resizable="false" :cell-class-name="getCellClassName">
      <el-table-column label="案号" prop="caseNum" />
      <el-table-column label="当事人" prop="ner" width="100px" />
      <el-table-column label="代理人" prop="agent" width="100px" v-if="type === 'ner'" />
      <el-table-column label="罪名" prop="crime" :width="type === 'label' ? '100px' : '200px'" />
      <template v-if="type === 'label'">
        <el-table-column label="标签1" width="100" />
        <el-table-column label="标签2" width="100" />
      </template>
    </el-table>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps(['type']);

const tableData = computed(() => {
  const arr = [
    { caseNum: '（2012) 部9004九216号', ner: '江风龙', agent: '张三', crime: '盗窃罪、抢劫罪' },
    { caseNum: '（2012) 部9004九216号', ner: '江风龙', agent: '李四	', crime: '盗窃罪、抢劫罪' },
    { caseNum: '（2018) 浑0110用初561号', ner: '孙明岐', agent: '王五	', crime: '强奸罪' },
    { caseNum: '（2019 内0102刊初415号', ner: '陈净', agent: '赵六	', crime: '盗窃罪' },
    { caseNum: '（2019 内0102刊初415号', ner: '苏赫', agent: '向高甲	', crime: '掩饰隐瞒罪' },
    { caseNum: '（2016）粤0704升初58号', ner: '谭国添', agent: '刘凤科	', crime: '抢夺罪' },
    { caseNum: '（2016）粤0704升初58号', ner: '苏穗', agent: '', crime: '抢夺罪' }
  ];

  if (props.type === 'label') {
    arr[0].crime = '盗窃罪';
    arr[1].crime = '抢劫罪';
  }

  return arr;
});

const getCellClassName = ({ rowIndex, columnIndex }) => {
  if (rowIndex <= 1 && (columnIndex === 1 || columnIndex === 2)) {
    return 'highlight';
  }

  return '';
};
</script>

<style lang="scss" scoped>
.label-group-preview {
  margin: 14px;

  ::v-deep .el-table {
    .el-table__header-wrapper tr th {
      background: #f8fafd;
    }
    .el-table__body-wrapper tr td.highlight {
      background: rgba(4, 200, 187, 0.08);
    }
  }
}
</style>
